<template>
  <v-container fluid>
    <v-parallax 
    :src="require('@/assets/citybridge.jpg')"
    aspect-ratio="1。7"
    height="300"
    class="my-2">
      <v-layout align-center justify-space-around row wrap fill-height>
        <h1 class="display-3 font-weight-thin white--text ma-2">关于Exicon投资银行</h1>
      </v-layout>
    </v-parallax>
    <v-layout row wrap
    text-xs-center
    justify-center>
      <v-flex xs12
      class="my-4">
        <v-layout row wrap text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-2 font-weight-thin">我们的服务焦点</h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-5 font-weight-thin">我们的成功来自于在我们熟知的行业和地区合作合适的客户类型。</h1>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://sociable.co/wp-content/uploads/2018/05/outsourcing-latin-america-1280x720.jpg"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">我们专注于拉丁美洲的公司。</div>
                <span class="grey--text">我们专注于帮助南美洲和加勒比地区的公司获取全球资本资源。</span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUPfRF0HG4ySmMdtel5y74t6aBdbQKrwORbQ&usqp=CAU"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">我们专注于具有差异化产品行业。</div>
                <span class="grey--text">如制造业，消费品，配送医疗保健和金融服务公司。</span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm6 md4
      class="my-2 px-2">
        <v-hover>
          <v-card
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`">
            <v-img
            src="https://www.thenakedheadhunter.com/wp-content/uploads/2017/04/boardroom-e1491318161397.jpg"
            height="250px"
            contain
            >
            </v-img>

            <v-card-title primary-title>
              <div>
                <div class="headline">我们专注于有领先市场地位的公司。</div>
                <span class="grey--text">
                  首选客户主要是市场领先的业务，年销售额超过2500万美元并且拥有健康的现金流。
                </span>
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12
      class="my-4">
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <h1 class="display-2 font-weight-thin my-2">我们的队伍</h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <h1 class="display-5 font-weight-thin my-2">
            受益于我们与全球资本市场的主要投资者的关系以及我们的专业交易结算经验。
          </h1>
        </v-layout>
        <v-layout row wrap
        text-xs-center
        justify-center
        class="my-2 mx-2">
          <v-expansion-panel popout>
            <v-expansion-panel-content
              v-for="(member, i) in members"
              :key="i"
              hide-actions
            >
              <v-layout
                slot="header"
                align-center
                row
                spacer
              >
                <v-flex xs4 sm2 md1>
                  <v-avatar
                    slot="activator"
                    size="48px"
                  >
                    <img
                      v-if="member.avatar"
                      :src="require('@/assets/' + member.avatar + '.png')"
                      alt="Team Member"
                    >
                  </v-avatar>
                </v-flex>

                <v-flex sm5 md3 hidden-xs-only>
                  <strong v-html="member.name"></strong>
                </v-flex>

                <v-flex no-wrap xs5 sm3>
                  <span v-html="member.title"></span>
                </v-flex>

                <v-flex
                  v-if="member.excerpt"
                  class="grey--text"
                  ellipsis
                  hidden-sm-and-down
                >
                  &mdash;
                  {{ member.excerpt }}
                </v-flex>
              </v-layout>

              <v-card>
                <v-divider></v-divider>
                <v-card-text>
                  <span>{{member.content}}</span>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        members: [
          {
            avatar: 'mario',
            name: 'Mario Lizana-Allende',
            title: '常务董事',
            excerpt: '2003年成立Exicon',
            content: 'Mario Lizana-Allende 在担任美国迈阿密毕马威会计师事务所拉丁美洲和加勒比地区经理后创立了 Exicon。他带来了多年的企业融资经验以及与美国、亚洲和欧洲最大的战略和金融投资者的关系。 Mario 拥有马德里康普顿斯大学的法律学位和马德里自治大学的工商管理硕士学位 - MBA 学位。他曾担任美国智利-美国商会主席，并担任哥伦比亚科伦坡智利商会创始委员会主席。他能说流利的西班牙语、德语和英语。'
          },
          {
            avatar: 'cecil',
            name: 'Cecil Yi Peng Ang (洪毅澎)',
            title: '董事',
            excerpt: '2016年加入Exicon',
            content: 'Cecil Ang在新加坡和美国加利福尼亚州硅谷成立金融科技公司Betafish Pte Ltd后加入Exicon。在Betafish之前，Cecil在Sands Capital Management LLC（美国）担任高级研究员五年，该投资公司管理超过100亿美元。Cecil毕业于美国弗吉尼亚大学，获得经济学和金融学最高荣誉，并且是特许金融分析师三级候选人。他说流利的英语，普通话和西班牙语。'
          }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/guanyu.vue